import React, { FC, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import useDataFromDom from './hooks/useDataFromDom';
import DealerLocator from './components/DealerLocator/DealerLocator.jsx';
import DealerNav from './components/DealerLocator/DealerNav';
import OnlineDealers from './components/DealerLocator/OnlineDealers';
import Distributors from './components/DealerLocator/DistributorContainer';
import ServiceCenters from './components/DealerLocator/ServiceCenters';

const Container = styled.div`
  min-height: 50vh;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 40px;
  }
`;
export interface DealerLocatorPageDomData {
  site?: any;
  country?: any;
  brandKey?: any;
  enableOnlineDealers?: any;
  enableDistributors?: any;
  enableDistributorsPage?: any;
  enableServiceCenters?: any;
}

const Index: FC = () => {
  const [view, setView] = useState('dealers');
  const { site, country, brandKey, enableOnlineDealers, enableDistributors, enableDistributorsPage, enableServiceCenters }: DealerLocatorPageDomData = useDataFromDom(['data-react'], 'dealer-nav-react-data');

  const handleViewChange = (view: any) => {
    setView(view);
  };

  return (
    <Container>
      <DealerNav enableOnlineDealers={enableOnlineDealers} enableDistributors={enableDistributors} enableServiceCenters={enableServiceCenters} enableDistributorsPage={enableDistributorsPage}
    handleViewChange={handleViewChange} view={view} />
     { view === 'dealers' ? (
      <DealerLocator page={'dealers'} />
    ) :
     view === 'online' ? (
      <OnlineDealers site={site} country={country} brandKey={brandKey} />
    ) : view === 'distributors' ? (
      <Distributors site={site} country={country} brandKey={brandKey} />
    ) : view === 'service' ? (
     <ServiceCenters site={site} country={country} brandKey={brandKey} />
    ) : null }
    </Container>
  );
};

ReactDOM.render(<Index />, document.getElementById('dealer-locator-react'));